/**
 * @exports NET_TRACKING_PAGE_NAME
 */
export const NET_TRACKING_PAGE_NAME = 'NET_ASSISTANT'
export const NET_MENU_TRACKING_PAGE_NAME = 'NET_ASSISTANT_MENU'

// ipromo to know if it comes to assistant page by expanding drawer
export const NET_ASSISTANT_PAGE_FULL_WIDTH_IPROMO = 'full-width-assistant'

/**
 * @exports NET_LOGO_URL_XS
 */
export const NET_LOGO_URL_XS = 'common/net-ai-assistant/net-logo-xs.svg'

/**
 * @exports NET_LOGO_URL_XS_INVERTED
 */
export const NET_LOGO_URL_XS_INVERTED = 'common/net-ai-assistant/net-logo-xs-inverted.svg'

export const NET_LOGO_EXTENDED_URL = 'common/net-ai-assistant/net_logo_fullscreen.svg'

// Increment when the localStorage schema changes to detect and discard stale entries
export const CHAT_STORAGE_SCHEMA_VERSION = 1

// Chat history older than 7 days is discarded
export const CHAT_HISTORY_TTL_DAYS = 7
export const CHAT_HISTORY_TTL_MS = CHAT_HISTORY_TTL_DAYS * 24 * 60 * 60 * 1000

// Maximum bytes per localStorage entry (50 KB); keeps individual values well under browser limits
export const CHAT_STORAGE_CHUNK_SIZE = 50 * 1024

export const DRAWER_REOPEN_SESSION_KEY = 'net_drawer_reopen'
export const NET_INPUT_USER_DEFAULT_MESSAGE_SESSION_KEY = 'net_input_user_default_message'

export const CHAT_STORAGE_KEYS = {
  // Single pointer to the active chat id; also carries the schema version
  INDEX: 'net_chat:index',
  // List of all chat IDs with metadata (title, savedAt)
  CHATS_LIST: 'net_chat:chats_list',
  // Per-chat metadata: savedAt timestamp, totalChunks count, and title
  chatMeta: id => `net_chat:chat:${id}`,
  // Ordered slice of the serialized chat payload; chunkIndex determines reconstruction order
  chunk: (id, chunkIndex) => `net_chat:chunk:${id}:${chunkIndex}`,
  // Prefix used to identify all chunk keys during orphan cleanup
  CHUNK_PREFIX: 'net_chat:chunk:'
}

/**
 * @exports MESSAGE_TYPES
 */
export const MESSAGE_TYPES = {
  CUSTOM: 'custom',
  PREDEFINED: 'predefined',
  MICRO: 'micro',
  MICRO_EDITED: 'micro edited'
}

/**
 * @exports FEEDBACK_REACTION_TYPES
 */
export const FEEDBACK_REACTION_TYPES = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative'
}

/**
 * @exports FEEDBACK_REVIEW_TAGS
 */
export const FEEDBACK_REVIEW_TAGS = {
  IRRELEVANT: {
    id: 'irrelevant',
    label: 'NET.FEEDBACK.REVIEW_TAGS.IRRELEVANT'
  },
  INCORRECT: {
    id: 'incorrect',
    label: 'NET.FEEDBACK.REVIEW_TAGS.INCORRECT'
  },
  OFFENSIVE: {
    id: 'offensive',
    label: 'NET.FEEDBACK.REVIEW_TAGS.OFFENSIVE'
  },
  REPETITIVE: {
    id: 'repetitive',
    label: 'NET.FEEDBACK.REVIEW_TAGS.REPETITIVE'
  },
  GENERIC: {
    id: 'generic',
    label: 'NET.FEEDBACK.REVIEW_TAGS.GENERIC'
  },
  OTHER: {
    id: 'other',
    label: 'NET.FEEDBACK.REVIEW_TAGS.OTHER'
  }
}

export {ASSISTANT_CHAT_PAGE_TYPE as NET_SUGGESTION_TYPE} from '../../assistant/ValueObjects/AssistantChatPageTypeValueObject.js'
